<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board ? board.readonly : false"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
export default {
  components: { FieldSelectModule, FileUploadModule },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    docProjectId: String | Number,
  },
  computed: {},
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.form && value) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss"></style>
